const USER_PICTURE_BASE_URL = "/services-accounts/api/v2/users";

export function getUserPictureUrl(
  userId: number,
  cacheVersion?: string | number,
): string {
  const url = `${USER_PICTURE_BASE_URL}/${userId}/picture`;
  if (cacheVersion === undefined) return url;

  return `${url}?${new URLSearchParams({ id: String(cacheVersion) })}`;
}
